import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { VirtualFolder } from '@modules/calendar-app/types/virtual-folder';
import { Application } from '@modules/common/types/application';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';

@Component({
  selector: 'app-events-list-context-menu',
  templateUrl: './events-context-menu.component.html',
  styleUrls: ['./events-context-menu.component.less'],
  standalone: false,
})
export class EventsContextMenuComponent {
  @Input() filterKey: VirtualFolder;

  @Output() change = new EventEmitter<VirtualFolder>();

  protected readonly searchService = inject(AdvancedSearchService);
  protected readonly isAdvancedSearchApplied = toSignal(
    this.searchService.isAdvancedSearchApplied(Application.calendar),
    {
      initialValue: false,
    },
  );

  selectFilter(filter: VirtualFolder) {
    this.change.emit(filter);
  }
}
